'use strict';

import {newModalFromSelector} from '../components/modal';
import Customer from '../account/customer';
import Plugins from 'util/plugins';
import RegistrationHelper from '../account/registrationHelper';
import UnifiedRegistration from '../account/unifiedRegistration';

class Header {
    init () {
        this.updateWishlistCounter();
        this.layerLogin();
        this.animateHeaderOnScroll();
        this.changeLogosPosition();
        this.setPageOnDOMLoaded();
        this.setPopupOnHoverTopPosition();
        this.setWishlistMinicartCounterOnDOMLoaded();
        this.setVideoWallButtons();
        RegistrationHelper.modalLoyaltyRegistrationInit();
        UnifiedRegistration.unifiedModalLoyaltyRegistrationInit();
        UnifiedRegistration.init();
        if ($('.cc-unified-page-card').length) {
            UnifiedRegistration.resetWizard();
        }
        Customer.resendActivationEmail();
        Customer.toggleVisiblePassword();
    }

    updateWishlistCounter () {
        // Update wishlist counter
        $('body').on('wishlist:update', function (e, total) {
            const $counter = $('.js-mainHeader-wishlist .js-mainHeader-counter');
            $counter.text(total);

            if (total > 0) {
                $counter.removeClass('hidden');
                $counter.closest('.js-mainHeader-wishlist').addClass('cc-mainHeader-wishlist_full');
            } else {
                $counter.addClass('hidden');
                $counter
                    .closest('.js-mainHeader-wishlist')
                    .removeClass('cc-mainHeader-wishlist_full');
            }
        });
    }

    layerLogin () {
        // Layer login must be disabled on the following pages
        var disabledPages = [
            'Login-Show',
            'Order-Confirm',
            'Account-NewRegistration',
            'Newsletter-Confirm',
        ];
        var currentPage = $('.page').data('action');
        var isLayerLoginDisabled = disabledPages.indexOf(currentPage) > -1;
        // Read by analytics (general_cta reg_flow_position)
        $('body').attr('data-layer-login-disabled', isLayerLoginDisabled ? 'true' : 'false');

        $('body').on(
            'click touchend',
            '.js-layer-login, .editProfilePersistent, .cartCustomerNotAuthenticated, .js-account-delete-persistent-button',
            function (e) {
                if (isLayerLoginDisabled) {
                    return;
                }
                e.preventDefault();
                e.stopImmediatePropagation();

                let isFromCart =
                    $('.cart-page').length && $('.cartCustomerNotAuthenticated').data('url');

                const onModalClose = () => {
                    UnifiedRegistration.unifiedCloseModalReloadOrLogout();
                    UnifiedRegistration.resetWizard();
                    if (isFromCart) {
                        $('body').trigger('cart:invalidatePersistentCustomerSession');
                    }
                };

                var modalClasses = ['layer-login-modal', 'cc-layer-login'];
                modalClasses.push('cc-registrationModal--unified-loyalty');

                var modal = newModalFromSelector(
                    'login-popup',
                    false,
                    modalClasses,
                    onModalClose
                );

                // Initialize new DOM element's form
                Plugins.init();
                RegistrationHelper.modalRegistrationInit();
                UnifiedRegistration.resetWizard();
                // Hide Remember Me Container for Modal in My Account
                if (
                    $('.page').data('action') === 'Account-Profile' ||
                    $('.page').data('action') === 'Account-Show'
                ) {
                    $('.remember-me-container').hide();
                }

                if ($(e.currentTarget).hasClass('editProfilePersistent')) {
                    Customer.accountLoginForm(false, $('#rurlDynamic'));
                } else {
                    Customer.accountLoginForm(true);
                }
                $('.close-button-info-popover').on('click', function (e) {
                    $('.popover-remember-me').hide();
                });

                $('.js-info-persistent').on('click', function (e1) {
                    e1.stopPropagation();
                    $('.info-rememberme').removeClass('hide');
                    $('body').on('click.closeTooltipEvent', function (e) {
                        if (
                            $(e.target).hasClass('close-button-info-tooltip') ||
                            $(e.target).closest('.info-rememberme').length === 0
                        ) {
                            $('.info-rememberme').addClass('hide');
                            $('body').off('click.closeTooltipEvent');
                        }
                    });
                });

                $('.cc-info-icon').on('click', function (e1) {
                    e1.stopPropagation();
                    $('.info-rememberme').toggleClass('hide');
                    $('body').on('click.closeTooltipEvent', function (e) {
                        if ($(e.target).hasClass('close-button-info-tooltip') || $(e.target).closest('.info-rememberme').length === 0) {
                            $('.info-rememberme').addClass('hide');
                            $('body').off('click.closeTooltipEvent');
                        }
                    });
                });

                $('.checkbox-label').on('click', function (e) {
                    return $(this).hasClass('policy-label');
                });

                $('body').on('change', '#rememberMeTwo', function (e) {
                    if ($('#rememberMeTwo').prop('checked')) {
                        $('.popover-remember-me').hide();
                    }
                });
                Customer.forgotPassword(modal);
                Customer.socialLoginHandler(true);
                if ($(e.currentTarget).hasClass('mobile-icon-layer-login')) {
                    $('#menuContainer').find('.js-intMenu-svgIcon_close').trigger('click');
                }
                modal.open();
                $(modal.modalBox).find('.social-login-form-error').addClass('hidden');
                $('.tingle-modal').addClass('wrapperModalLogin');
                $(modal.modalBox).addClass('rightModalAttribute');

                $(modal.modalBox)
                    .find('.close-button')
                    .on('click', function (e) {
                        if (isFromCart) {
                            $('body').trigger('cart:invalidatePersistentCustomerSession');
                        }
                        modal.close();
                    });

                $('body').one('socialLoginError:standardCustomer', function (e) {
                    modal.close();
                    modal.destroy();
                });
            }
        );
    }

    animateHeaderOnScroll () {
        if ($('.js-page-home-gender').length > 0) {
            $(document).on('scroll', function () {
                if ($(window).scrollTop() > $('.js-mainHeader').height()) {
                    $('.js-mainHeader').addClass('cc-solid');
                } else {
                    $('.js-mainHeader').removeClass('cc-solid');
                }
            });
        } else {
            $('.js-mainHeader').addClass('cc-solid');
        }
    }

    changeLogosPosition () {
        $('.js-mainHeader-item_logo').html($('.js-logo').html());
        if ($('.js-intMenu').attr('data-post-split') === 'true') {
            $('.js-mainHeader-item_tabGender').remove();
        } else {
            $('.js-mainHeader-item_tabGender').html($('.js-tabGender').html());
        }
        $('.js-logo, .js-tabGender').remove();
    }

    setPageOnDOMLoaded () {
        if ($('.js-page-home-gender').length > 0) {
            $('.js-page-home-gender').addClass('cc-inHomepage');
        } else {
            if ($('.js-mainHeader-container').css('position') === 'fixed') {
                $('.page').css('padding-top', $('.js-mainHeader').innerHeight());
            } else {
                $('.page').css('padding-top', '0');
            }
        }

        if ($('.js-isHeaderLight').length > 0) {
            $('.js-mainHeader').addClass('cc-light');
        }

        if ($('.page').data('action') === 'Product-Show' && !Foundation.MediaQuery.atLeast('large')) {
            if (history.scrollRestoration) {
                history.scrollRestoration = 'manual';
            }
            $('html').animate({scrollTop: $('.js-mainHeader-container').innerHeight() + $('.js-breadcrumb').innerHeight() + 'px'}, 700);
        }

        let sovraHeaderHeight = $('.cc-promoStrip').outerHeight();
        let headerHeight = $('.js-mainHeader').outerHeight();
        let dashboardHeight = $('.js-subHeaderMobile ').outerHeight();
        document.documentElement.style.setProperty('--sovraHeaderHeight', sovraHeaderHeight + 'px');
        document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px');
        document.documentElement.style.setProperty('--dashboardHeight', dashboardHeight + 'px');
    }

    setPopupOnHoverTopPosition () {
        $('.js-mainHeader-login').on('mouseenter', function () {
            const elements = document.getElementsByClassName('js-mainHeader');
            if (elements.length === 0) {
                return;
            }
            const element = elements[0];
            const boundingRect = element.getBoundingClientRect();
            const positionTop = boundingRect.top + boundingRect.height;
            document.getElementsByClassName('js-mainHeader-login-onHover')[0].style.top = `${positionTop}px`;
        });

        $('.js-mainHeader-login').hover(
            function () {
                $(this).addClass('is-login-popup-on-top');
                $('.js-plp-refineBar').removeClass('z-top').addClass('z-bottom');
            },
            function () {
                $(this).removeClass('is-login-popup-on-top');
                if ($('.js-mainHeader').hasClass('z-bottom')) {
                    $('.js-plp-refineBar').removeClass('z-bottom').addClass('z-top');
                }
            }
        );
    }

    setWishlistMinicartCounterOnDOMLoaded () {
        if (!$('.js-mainHeader-wishlist .js-mainHeader-counter').hasClass('hidden')) {
            $('.js-mainHeader-wishlist').addClass('cc-mainHeader-wishlist_full');
        } else {
            $('.js-mainHeader-wishlist').removeClass('cc-mainHeader-wishlist_full');
        }

        if (!$('.js-mainHeader-counter_minicart').hasClass('hidden')) {
            $('.js-mainHeader-minicart').addClass('cc-mainHeader-minicart_full');
        } else {
            $('.js-mainHeader-minicart').removeClass('cc-mainHeader-minicart_full');
        }
    }

    setVideoWallButtons () {
        $('.js-mainHeader-button-back').on('click', function (e) {
            if (window.history.length > 1) {
                history.back();
            }
        });
    }
}

const header = new Header();
export default header;
